import { Button, Card, CardContent, Progress } from "alm-react-components";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { badgeUrl, limitOverview } from "../../../lib/utils";
import SvgIcon from "../SvgIcon";
import { constants } from "../../../assets/constants/constants";

const FundamentalProgramCard = ({ cardInfo, showSeeAll }: any) => {
  const navigate = useNavigate();
  return (
    <div className="w-[100%] mx-auto py-6 md:py-14 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="md:flex md:items-center lg:justify-between mb-4 md:mb-0">
        <div className="min-w-0 flex-1 md:pb-8">
          <h1
            className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
            dangerouslySetInnerHTML={{
              __html: t("Program.fundamentalProgram"),
            }}
          />
        </div>
        {showSeeAll && (
          <div className="mt-5 flex lg:ml-4 lg:mt-0 mb-4 md:mb-0 md:pb-6 lg:pb-12">
            <Button
              onClick={() => navigate("/mystance-all-programs")}
              variant="secondary"
              className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard"
              dangerouslySetInnerHTML={{ __html: t("MyStance.seeAllPrograms") }}
            />
          </div>
        )}
      </div>

      <Card className="dark:card-gradient-gray dark:text-white dark:border-cardBorder rounded-2xl">
        <CardContent className="grid gap-4 md:py-10 md:px-8 md:pb-7 py-6">
          <div className="flex items-start md:pb-14">
            <div className="flex-1 min-w-0 me-4">
              <h1 className="scroll-m-20 lg:text-3xl xl:text-4xl font-normal">
                {cardInfo.name}
              </h1>
              <p className="leading-7 [&:not(:first-child)]:mt-6 md:w-[52%]">
                {cardInfo && limitOverview(cardInfo?.description)}
              </p>
            </div>
            <div className="flex-shrink-0 inline-flex items-start text-base font-opensansSemiBold text-gray-900 dark:text-white ">
              <Button
                onClick={() => navigate(`/program/learningProgram`)}
                variant="link"
                className="w-full yellow space-y-1.5 space-x-1.5 px-0 h-auto text-base font-normal bg-transparent py-1 md:min-h-10 dark:text-white"
              >
                {(cardInfo.programStatus == constants.STARTED ||cardInfo.programStatus == constants.COMPLETED  )?t("Common.continue"): t("Program.startHere") }
                <SvgIcon
                  iconName="arrow-right" 
                  svgProp={{
                    className: "logo ms-3 text-sm",
                  }}
                />
              </Button>
            </div>
          </div>
          <div className="flex items-end">
            <div className="flex-1 min-w-0 me-4 mb-2">
              <p className="leading-7 [&:not(:first-child)]:mt-6 md:w-72 dark:text-gray-300 font-light">
                <span
                  dangerouslySetInnerHTML={{
                    __html: `${cardInfo.weeks} ${t("Common.parts")}`,
                  }}
                />
              </p>
            </div>
            <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white mb-2">
              <img
                className=" w-20 h-20 yellow"
                src={badgeUrl(cardInfo?.relationShipId, cardInfo?.included)}
                alt="Basics image"
              />

              {/* <Button
                onClick={() => navigate(`/program/learningProgram`)}
                variant="outline"
                className="w-full space-y-1.5 space-x-1.5 h-auto text-base font-normal bg-transparent py-1 md:min-h-10 md:px-14 dark:border-white"
              >
                <span
                  dangerouslySetInnerHTML={{ __html: t("Program.goToProgram") }}
                />
                <FontAwesomeIcon icon={faArrowRight} className="ms-3 text-sm" />
              </Button> */}
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex-1 min-w-0">
              <Progress
                value={cardInfo.progress}
                className="w-full h-[7px] bg-fillDarkGrayCard"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
export default FundamentalProgramCard;
